import React from 'react'
import { FormGroup, Alert } from "reactstrap"
import { connect } from "react-redux"

const AlertField = (props) => {
  const { form } = props

  return (
    <FormGroup>
      <Alert className="w-100" color="warning" isOpen={form.error !== null}>
        <p className="m-0 p-1">{form.error}</p>
      </Alert>
    </FormGroup>
  )
}

const mapStateToProps = state => {
  return {
    form: state.form
  }
}

export default connect(mapStateToProps)(AlertField)
